export default "__VITE_ASSET__17f3b487__"